import GetTheApp from '@/components/get-the-app';

export default GetTheApp;
